<template>
  <div id="homeReasonsDetalizationAllTimeCountsPanel" class="panel shadow-none pt-15 pl-15">
    <h3 class="panel-title text-center pr-0 pb-20">Детализация причин (за всё время)
      <i aria-hidden="true"
         data-toggle="popover"
         data-html="true"
         data-trigger="click | hover"
         data-content="Рассчитывается на основании человек-группа"
         class="icon md-help-outline cursor-pointer"
         data-original-title="" title=""></i>
    </h3>
    <div class="row">
      <div class="col-12 mb-20" v-for="(stat, type) in stats">
        <div class="row">
          <div class="col-2">
            <div class="pearl red active">
              <span class="pearl-icon cursor-pointer" :class="stat.color" :style="stat.line_height_style">
                <span v-if="stat.error" class="error">
                    <i class="fa fa-exclamation-triangle" :class="stat.color" aria-hidden="true"></i>
                </span>

                <span v-if="!stat.error && stat.loading" class="loading">
                    <i class="fa fa-spinner fa-pulse" :class="stat.color" aria-hidden="true"></i>
                </span>

                <span v-if="!stat.error && !stat.loading" :style="stat.font_style">
                  {{ stat.count }}
                </span>
              </span>
            </div>
          </div>
          <div class="col-10"><span class="description-reason-detail">{{ stat.title }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReasonsDetalizationAllTimeCountsPanel',
  data() {
    return {
      stats: {
        not_informed : {
          loading          : true,
          error            : false,
          count            : 0,
          color            : 'pearl-icon-blue',
          title            : 'Своевременно не проинформированы',
          font_style       : '',
          line_height_style: '',
        },
        ignoring     : {
          loading          : true,
          error            : false,
          count            : 0,
          color            : 'pearl-icon-purple',
          title            : 'Игнорирование назначенного обучения',
          font_style       : '',
          line_height_style: '',
        },
        not_completed: {
          loading          : true,
          error            : false,
          count            : 0,
          color            : 'pearl-icon-red',
          title            : 'Не завершили обучение в установленные сроки',
          font_style       : '',
          line_height_style: '',
        },
        not_passed   : {
          loading          : true,
          error            : false,
          count            : 0,
          color            : 'pearl-icon-yellow',
          title            : 'Допущенные, но не сдававшие экзамен',
          font_style       : '',
          line_height_style: '',
        },
      },
    };
  },
  methods: {
    get_data() {
      axios.get('/widgets/DetailsOfReasonsByMonths/0').then((response) => {
        Object.keys(response.data).map((type) => {
          this.stats[type].count             = response.data[type];
          this.stats[type].font_style        = this.font_size(this.stats[type].count);
          this.stats[type].line_height_style = this.line_height(this.stats[type].count);
          this.stats[type].loading           = false;
        });
      }).catch((err) => {
        console.log(err);
        Object.keys(this.stats).map((type) => {
          this.stats[type].error = true;
        });
      });

      // Object.keys(this.stats).map((type) => {
      //   axios.get(`/widgets/ReasonsDetalizationAllTimeCounts/${ type }`).then(response => {
      //     this.stats[type].count             = response.data.count;
      //     this.stats[type].font_style        = this.font_size(this.stats[type].count);
      //     this.stats[type].line_height_style = this.line_height(this.stats[type].count);
      //     this.stats[type].loading           = false;
      //
      //   }).catch(error => {
      //     this.stats[type].error = true;
      //   });
      // });
    },
    font_size(content) {
      const len = content.toString().length;

      const styles = {
        4: 'font-size: 11pt',
        5: 'font-size: 9pt',
      };

      return Object.keys(styles).indexOf(len.toString()) !== -1 ? styles[len] : '';
    },
    line_height(content) {
      const len = content.toString().length;

      const styles = {
        4: 'line-height: 38px',
        5: 'line-height: 36px',
      };

      return Object.keys(styles).indexOf(len.toString()) !== -1 ? styles[len] : '';
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.md-help-outline {
  color: rgb(255, 102, 17);
}

.panel-title {
  padding-top: 7px;
}

.error {
  color: red;
}

.fa {
  font-size: 18px;
}

.mb-20 {
  height: 81.5px;
}

.mb-20:last-of-type {
  margin-bottom: 11px !important;
}
</style>
